import state from './moduleCreateScheduleState.js'
import mutations from './moduleCreateScheduleMutations.js'
import actions from './moduleCreateScheduleActions.js'
import getters from './moduleCreateScheduleGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}